/**
 * Basis-URL des Backends. Einzige Quelle für VITE_API_BASE_URL — sie wird von beiden
 * Axios-Instanzen, der Sentry-Trace-Propagation und der Health-Probe gelesen.
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL || 'https://localhost:7248';

/** Basis-URL ohne abschließenden Slash — für Pfad-Konkatenation. */
export const apiUrl = (path: string): string =>
  `${API_BASE_URL.replace(/\/$/, '')}${path}`;
